import _ from 'lodash'

/**
 * Converts a showX property name (eg `showBudgetSpent`) to the corresponding
 * value used by shapeTextProperty (eg `budget-spent`)
 */
function textPropertyToShowProperty (textProperty) {
	if (_.isEmpty(textProperty)) {
		return null
	}

	let camelCase = _.camelCase(textProperty)
	return 'show' + camelCase.charAt(0).toUpperCase() + camelCase.slice(1)
}

export default textPropertyToShowProperty

textPropertyToShowProperty.__filename__ = 'dashboards/widgets/shape/text-property-to-show-property.js'
